import { call, put, takeLatest } from "redux-saga/effects";
import {
    addWardFailure,
    addWardSuccess,
    deleteWardFailure,
    deleteWardSuccess,
    fetchAllWardsFailure,
    fetchAllWardsSuccess,
    fetchWardFailure,
    fetchWardsFailure,
    fetchWardsSuccess,
    fetchWardSuccess,
    fetchWeekIdFailure,
    fetchWeekIdSuccess,
    updateWardFailure,
    updateWardSuccess,
} from "./wardAction";
import {
    addWardEffect,
    deleteWardEffect,
    editWardEffect,
    listAllWardEffect,
    listWardAllEffect,
    listWardEffect,
    listWardEffectByWeekId,
    viewWardEffect,
} from "./wardEffect";
import {
    ADD_WARD_REQUEST,
    DELETE_WARD_REQUEST,
    FETCH_LIST_ALL_WARD_REQUEST,
    FETCH_LIST_ALLS_WARD_REQUEST,
    FETCH_LIST_WARD_REQUEST,
    FETCH_LIST_WEEK_ID_REQUEST,
    FETCH_WARD_REQUEST,
    UPDATE_WARD_REQUEST
} from "./wardType";

function* fetchWardsSaga(action) {
    try {
        const wards = yield call(listWardEffect, action.payload);
        
        yield put(fetchWardsSuccess(wards));
    } catch (error) {
        yield put(fetchWardsFailure(error.message));
    }
}
function* fetchAllWardsSaga(action) {
    try {
        const wards = yield call(listAllWardEffect, action.payload);
        yield put(fetchAllWardsSuccess(wards));
    } catch (error) {
        yield put(fetchAllWardsFailure(error.message));
    }
}

function* fetchWardsAllSaga(action) {
    try {
        const wards = yield call(listWardAllEffect, action.payload);
        yield put(fetchAllWardsSuccess(wards));
    } catch (error) {
        yield put(fetchAllWardsFailure(error.message));
    }
}
function* fetchWardSaga(action) {
    try {
        const ward = yield call(viewWardEffect, action.payload.wardId);
        yield put(fetchWardSuccess(ward));
    } catch (error) {
        yield put(fetchWardFailure(error.message));
    }
}
function* fetchWardWeekIdSaga(action) {
    
    try {
        const ward = yield call(listWardEffectByWeekId, action.payload.wardId);

        yield put(fetchWeekIdSuccess(ward));
    } catch (error) {
     
        yield put(fetchWeekIdFailure(error.message));
    }
}

function* addWardSaga(action) {
    try {
        const newWard = yield call(addWardEffect, action.payload.wardData);
        yield put(addWardSuccess(newWard));
    } catch (error) {
        const backendMessage = error.response?.data?.message || error.message || "Login failed";
        yield put(addWardFailure(backendMessage));
    }
}

function* updateWardSaga(action) {
    try {
        const updatedWard = yield call(
            editWardEffect,
            action.payload.wardId,
            action.payload.wardData
        );
        yield put(updateWardSuccess(updatedWard));
    } catch (error) {
        const backendMessage = error.response?.data?.message || error.message || "Login failed";

        yield put(updateWardFailure(backendMessage));
    }
}

function* deleteWardSaga(action) {
    try {
        yield call(deleteWardEffect, action.payload.wardId);
        yield put(deleteWardSuccess(action.payload.wardId));
    } catch (error) {
        yield put(deleteWardFailure(error.message));
    }
}

export function* wardSagas() {
    yield takeLatest(FETCH_LIST_WARD_REQUEST, fetchWardsSaga);
    yield takeLatest(FETCH_WARD_REQUEST, fetchWardSaga);
    yield takeLatest(ADD_WARD_REQUEST, addWardSaga);
    yield takeLatest(UPDATE_WARD_REQUEST, updateWardSaga);
    yield takeLatest(DELETE_WARD_REQUEST, deleteWardSaga);
    yield takeLatest(FETCH_LIST_ALL_WARD_REQUEST,fetchAllWardsSaga)
    yield takeLatest(FETCH_LIST_WEEK_ID_REQUEST, fetchWardWeekIdSaga);
     yield takeLatest(FETCH_LIST_ALLS_WARD_REQUEST, fetchWardsAllSaga);
}